export default "__VITE_PUBLIC_ASSET__cde0ba34__"